import React from 'react';
import ModalShell from '../ModalShell/ModalShell';
import './ManagementModalLayout.css';

interface ManagementModalLayoutProps {
  ariaLabel: string;
  title: string;
  closeAriaLabel: string;
  onClose: () => void;
  className?: string;
  addButtonLabel?: string;
  addButtonAriaLabel?: string;
  onAdd?: () => void;
  sidebar: React.ReactNode;
  form: React.ReactNode;
}

const ManagementModalLayout: React.FC<ManagementModalLayoutProps> = ({
  ariaLabel,
  title,
  closeAriaLabel,
  onClose,
  className = '',
  addButtonLabel,
  addButtonAriaLabel,
  onAdd,
  sidebar,
  form,
}) => (
  <ModalShell
    onClose={onClose}
    ariaLabel={ariaLabel}
    className={`modal management-modal ${className}`.trim()}
    showCloseButton={false}
  >
    <div className="management-modal-header">
      <div className="management-modal-title-row">
        <h3 style={{ margin: 0 }}>{title}</h3>
        {onAdd ? (
          <button
            type="button"
            className="management-modal-add management-modal-add--icon"
            onClick={onAdd}
            aria-label={addButtonAriaLabel ?? addButtonLabel}
            title={addButtonLabel}
          >
            +
          </button>
        ) : null}
      </div>
      <button type="button" className="management-modal-close" onClick={onClose} aria-label={closeAriaLabel}>
        x
      </button>
    </div>

    <div className="management-modal-layout">
      <div className="management-modal-sidebar">{sidebar}</div>
      <div className="management-modal-form">{form}</div>
    </div>
  </ModalShell>
);

export default ManagementModalLayout;
